import { useEffect, useState } from 'react';
import axios from "axios";
import ReactDOMServer from 'react-dom/server';
import { AppMultiSelect, AppRemixIcon, AppSingleSelect } from '@/layout/AppComponents';
import BtnOptions from './BtnOptions';
import Translator from '../../../../components/helpers/Translator';
import { axiosPath } from '../../../../../routing/helpers/router';
import useIsMounted from '../../../../components/hooks/useIsMounted';

const Report27Options = (props) => {
  const {
    handleOnSetFieldValue,
    handleOnSubmit,
    handleOnSave,
    values,
    selectedReport,
  } = props;
  const isMounted = useIsMounted();
  const [reportOptions, setReportOptions] = useState();

  // > LOAD REPORT OPTIONS //
  useEffect(() => {
    axios
      .post(axiosPath("api_r_user_module_intelligence_getReportOptions"), {
        report: 27,
        selectedReport,
      })
      .then((r) => {
        if (isMounted.current) {
          setReportOptions(r.data);
        }
      })
      .catch(() => "");
  }, []);
  // < LOAD REPORT OPTIONS //

  if (!reportOptions) return <></>;

  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <AppSingleSelect
            icon={<AppRemixIcon icon="shuffle" />}
            options={reportOptions?.gcl || []}
            title={<Translator file="module-legalCompliance" name="gclName" />}
            placeholder={ReactDOMServer.renderToString(
              <Translator file="module-intelligence" name="select.an.option" />
            )}
            value={values?.gcl}
            onChange={(opt) => handleOnSetFieldValue('gcl', opt)}
            isLoading={!reportOptions?.gcl}
            hasSearchBox
          />
        </div>
      </div>
      {values?.gcl && (
        <div className="row">
          <div className="col-sm-12">
            <AppMultiSelect
              options={reportOptions?.plants?.[values?.gcl] || []}
              onChange={(e) => handleOnSetFieldValue('plants', e)}
              title={<Translator file="user" name="user.plants" />}
              icon={<AppRemixIcon icon="layout-column" />}
              placeholder={ReactDOMServer.renderToString(
                <Translator
                  file="module-intelligence"
                  name="module.int.plants-select"
                />
              )}
              value={values.plants || []}
              isMulti
              hasSearchBox
              hasSelectOptions
            />
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-12">
              <BtnOptions
                isDisabled={
                  !values.gcl || !values.plants || values.plants.length === 0
                }
                handleOnSave={() => handleOnSave(true)}
                handleOnSubmit={() => handleOnSubmit()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Report27Options;
